var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications-item-base',{attrs:{"title":_vm.notification.title,"read":_vm.notification.read,"link":`/payments/?id=${_vm.notification.data.id}`,"body":_vm.notification.body,"time":_vm.notification.time,"icon":_vm.icon,"color":_vm.color,"notification-id":_vm.notification.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }